import { gql } from '@apollo/client';

/** Scoped to the caller by the service, so there is no requester to pass. */
export const BULK_UPLOADS = gql`
  query BulkUploads($status: BulkUploadStatus, $page: Int, $size: Int) {
    bulkUploads(status: $status, page: $page, size: $size) {
      content {
        uploadToken
        label
        filename
        status
        insertTz
        requestedActions {
          type
          statusCode
          reasonCode
          attributes
        }
      }
      totalElements
    }
  }
`;

export const BULK_UPLOAD = gql`
  query BulkUpload($uploadToken: String!) {
    bulkUpload(uploadToken: $uploadToken) {
      uploadToken
      label
      filename
      status
      errorMessage
      insertTz
      requestedActions {
        type
        statusCode
        reasonCode
        attributes
      }
      rows {
        total
        pending
        byStatus {
          status
          count
        }
      }
      steps {
        taskId
        outcomes {
          outcome
          count
        }
      }
    }
  }
`;

export const BULK_UPLOAD_ROWS = gql`
  query BulkUploadRows(
    $uploadToken: String!
    $status: BulkRowStatus
    $page: Int
    $size: Int
  ) {
    bulkUploadRows(
      uploadToken: $uploadToken
      status: $status
      page: $page
      size: $size
    ) {
      content {
        lineNumber
        sourceId
        status
        processedTz
        tasks {
          taskId
          outcome
          detail
        }
      }
      totalElements
    }
  }
`;
